import { render, staticRenderFns } from "./Supervisor.vue?vue&type=template&id=d0c45e6c&scoped=true"
import script from "./Supervisor.vue?vue&type=script&lang=js"
export * from "./Supervisor.vue?vue&type=script&lang=js"
import style0 from "./Supervisor.vue?vue&type=style&index=0&id=d0c45e6c&prod&lang=css"
import style1 from "./Supervisor.vue?vue&type=style&index=1&id=d0c45e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c45e6c",
  null
  
)

export default component.exports